<!-- ! 新的优惠券流程 - 预览提现的时候选择-->
<template>
  <div class="coupon-list">
    <navigation>我的优惠券</navigation>
    <div class="list-container">
      <div class="item" :class="{ disable: item.canUse !=='Y', select: selectedId===index }" v-for="(item,index) in list" :key="index" @click="toggleSelect(index,item.canUse !=='Y')">
        <div class="item-detail">
          <div class="name">免息券</div>
          <div class="value">{{ item.discountValue }}</div>
          <div class="unit">{{item.discountType | unit}}</div>
          <div class="ui-radio"></div>
        </div>
        <div class="overdue-time">有效期至 {{ item.expireDate | formateTime }}</div>
        <div class="disable-info" v-if="item.canUse !=='Y'">
          <div class="disable-info-title">该券暂不可用</div>
          <!-- @click.stop="$router.push(`/coupon/detail-v3-interest-free?couponRecordId=${item.couponSerialNo}`)" -->
          <div class="disable-info-detail" >可在我的-券包点击【详情】找到使用规则</div>
        </div>
      </div>
    </div>
    <div class="info">
      <h3>特别说明：</h3>
      <p>1、免息券仅限提现成功使用，未提现成功，有效期内券自动返还。</p>
      <p>2、1笔借款申请仅能关联1张免息券。</p>
      <p>3、其他情况，未使用成功，则借据将按原定还款计划生成还款。</p>
    </div>
    <div class="footer">
      <nd-button @click="select">确认</nd-button>
    </div>
  </div>
</template>

<script>
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { mapActions } from 'vuex'
import wx from 'weixin-webview-jssdk'
import { isTMDMiniprogram } from '@/assets/utils'
export default {
  data () {
    return {
      selectedId: '',
      list: [],
      query: this.$route.query
    }
  },
  filters: {
    unit (type) {
      const map = {
        'FREE_AMOUNT': '元',
        'FREE_DAY': '天'
      }
      return map[type]
    }
  },
  async mounted () {
    await this.loanUseRecord()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('coupon', ['loanUseRecordX']),
    toggleSelect (index, disabled) {
      if (disabled) return
      if (this.selectedId === index) {
        this.selectedId = ''
        return
      }
      this.selectedId = index
    },
    async loanUseRecord () {
      const { applyAmt } = this.$route.query
      const response = await this.loanUseRecordX({
        loanAmt: applyAmt
      })
      if (response.success) {
        this.list = response.data || []
        const { couponSerialNoV3 } = this.$route.query
        if (couponSerialNoV3) {
          this.selectedId = this.list.findIndex(item => item.couponSerialNo === couponSerialNoV3)
        }
      }
    },
    select () {
      const couponId = this.selectedId || this.selectedId === 0 ? this.list[this.selectedId]?.couponSerialNo : ''
      if (!couponId) {
        sessionStorage.removeItem('couponSerialNoV3')
      }
      if (hasNativeMethod('selectedCouponInfo') && this.$route.query.androidPreview === 'Y') {
        jsBridge('selectedCouponInfo', { couponId })
      } else if (isTMDMiniprogram()) {
        wx.miniProgram.postMessage({
          data: { 
            eventType: 'WITHDRAW_PREVIEW',
            value: JSON.stringify({
              ...this.query,
              couponCash: couponId || 'NONE',
              replace: 'Y'
          }) }
        })
        wx.miniProgram.navigateBack()
      } else {
        this.$router.replace({
          path: '/withdraw/preview',
          query: {
            ...this.query,
            couponSerialNoV3: couponId || 'NONE'
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.coupon-list {
  min-height: 100vh;
  background: #FAFAFA;
  position: relative;

  .list-container {
    display: flex;
    padding: 20px 40px;
    flex-direction: column;

    .item {
      width: 670px;
      background: #FFFFFF;
      box-shadow: 5px 10px 20px 0px #EEEEEE;
      border-radius: 20px;
      padding: 66px 20px 0;
      margin-bottom: 20px;

      .item-detail {
        display: flex;
        align-items: center;

        .name {
          flex: 1;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 34px;
          color: #333333;
        }

        .value {
          font-family: DIN, DIN;
          font-weight: 500;
          font-size: 50px;
          color: #FF4633;
        }

        .unit {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #333333;
          padding: 10px 20px 0 5px;
        }

        .ui-radio {
          width: 32px;
          height: 32px;
          border:1px solid #aaa;
          border-radius: 100px;
        }

      }

      .overdue-time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #999999;
        line-height: 28px;
        padding: 15px 0;
      }

      .disable-info {
        border-top: 1px solid #eee;
        font-size: 24px;
        padding: 14px 0;

        .disable-info-title {
          color: #FF4633
        }

        .disable-info-detail {
          color: #999;
        }
      }
      &.select {
        .ui-radio {
        border:none;
          background: url('./images/circle_selected@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      &.disable {
        .ui-radio {
          border:none;
          background: url('./images/circle_disable@2x.png') no-repeat;
          background-size: 100% 100%;
        }

        .overdue-time,
        .name,
        .value,
        .unit {
          opacity: 0.5;
        }
      }
    }
  }

  .info {
    padding: 40px;
    padding-bottom: 200px;
    font-size: 28px;

    h3 {
      color: #333333;
      padding-bottom: 8px;
    }

    p {
      color: #666666;
      margin-top: 8px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    height: 180px;
    width: 10rem;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>